import type { Session } from "next-auth";

/**
 * Whether the session has a usable access token for API calls and auto-redirect.
 * Prevents redirect loops when the NextAuth cookie exists but the API token is stale.
 */
export function isSessionHealthyForAutoRedirect(
  session: Session | null | undefined,
): boolean {
  if (!session?.user) return false;
  if (session.error) return false;
  if (!session.accessToken) return false;
  if (session.expiresAt != null && Date.now() >= session.expiresAt) {
    return false;
  }
  return true;
}
